import React from "react";

// ProSoftware logo loader. The outer dark-blue mark stays fixed; only the inner
// refresh arrows rotate clockwise around the logo's centre (95.5, 95.5 in the
// 190x190 viewBox). Keyframes live in App.css as `logo-loader-spin`.
//
// Props:
//   size     rendered width/height in px
//   duration seconds per full turn
//   steps    0 = smooth rotation, 12 = discrete 30° frames
//   label    accessible name announced to screen readers

const OUTER_MARK =
  "M1.000000,93.416664 C1.607639,89.523949 2.315268,86.062004 2.807765,82.569717 C9.160404,37.523151 47.319641,3.131237 92.237862,2.003457 C139.119476,0.826381 179.235657,32.962879 187.751526,78.518097 C198.209015,134.459869 156.865524,186.426819 99.802101,189.194077 C84.535873,189.934387 70.079437,186.987778 56.127655,180.890640 C52.917271,179.487686 51.791004,177.673920 51.909443,174.163544 C52.187889,165.910645 51.998623,157.641998 51.998623,148.565170 C61.104256,155.286865 70.225380,160.276596 80.635956,162.320282 C107.892189,167.670944 131.058319,160.012680 148.465576,138.487183 C166.157578,116.609589 169.108551,91.780869 156.944733,66.387596 C144.886948,41.215729 124.003922,27.983990 95.978050,27.660551 C57.521160,27.216730 27.180050,57.833447 27.164371,96.296097 C27.156559,115.459648 27.163008,134.623199 27.163006,153.786743 C27.163006,155.367645 27.163006,156.948563 27.163006,159.844025 C10.716660,141.626343 2.843709,121.414177 1.376125,98.198364 C1.000000,96.611107 1.000000,95.222221 1.000000,93.416664 z";

const UPPER_ARROW =
  "M66.293228,114.816933 C64.913712,114.717293 63.599342,114.596764 62.726814,113.912674 C57.633598,109.919487 52.643932,105.794212 47.126129,101.313019 C48.978439,100.668037 50.400036,100.173035 51.822250,99.677811 C50.518147,76.830261 65.427299,55.177711 91.955383,52.303982 C108.990227,50.458641 129.927185,62.458973 133.834656,76.753326 C130.902130,74.409088 128.159241,72.216454 125.182495,69.836876 C121.244995,74.653725 117.470200,79.271530 113.016685,84.719627 C112.041290,83.344284 111.374382,81.996078 110.349701,81.025658 C103.982689,74.995872 96.483948,73.104935 88.267952,76.190514 C80.521179,79.099869 75.977730,84.906052 74.808006,93.275078 C74.361992,96.466125 74.739456,98.630676 79.809547,97.933609 C74.963463,104.007042 70.762978,109.271378 66.293228,114.816933 z";

const LOWER_ARROW =
  "M58.143684,115.844398 C60.561253,117.565842 62.978821,119.287292 65.904655,121.370651 C69.744408,116.815338 73.627449,112.208672 77.743156,107.325974 C85.563156,116.052551 94.494354,119.434326 105.159348,114.166565 C112.837517,110.374107 116.682144,102.903206 115.859558,94.229889 C114.529755,94.085709 113.129425,93.933876 111.017632,93.704903 C116.044006,87.467445 120.767693,81.605621 125.749329,75.423698 C131.950470,80.412376 137.743790,85.072968 144.169479,90.242287 C142.153870,90.757439 140.855377,91.089310 139.616867,91.405846 C137.712906,120.992393 123.789154,139.072067 92.478386,138.826050 C77.064682,138.704956 65.554314,130.365784 57.818871,116.596939 C57.872566,116.124916 58.143684,115.844398 58.143684,115.844398 z";

const LOWER_ARROW_SLIVER =
  "M57.733601,116.261795 C57.703114,116.068184 57.811592,115.737686 58.031876,115.625793 C58.143684,115.844398 57.872566,116.124916 57.733601,116.261795 z";

const LogoLoader = ({
  size = 48,
  duration = 1.8,
  steps = 0,
  label = "Loading",
  className = "",
}) => {
  const timing = steps > 0 ? `steps(${steps}, end)` : "linear";

  return (
    <svg
      role="img"
      aria-label={label}
      viewBox="0 0 190 190"
      width={size}
      height={size}
      className={className}
      style={{ display: "block", flexShrink: 0 }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill="#1860A1" d={OUTER_MARK} />
      <g
        style={{
          transformOrigin: "95.5px 95.5px",
          animation: `logo-loader-spin ${duration}s ${timing} infinite`,
        }}
      >
        <path fill="#1A61A2" d={UPPER_ARROW} />
        <path fill="#45B2FC" d={LOWER_ARROW} />
        <path fill="#45B2FC" d={LOWER_ARROW_SLIVER} />
      </g>
    </svg>
  );
};

export default LogoLoader;
